import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { setAuth } from '../Redux/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { RootState } from '../Redux/store';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import { FaFilePdf, FaFileExcel, FaPrint, FaUserGraduate, FaSearch, FaEye } from 'react-icons/fa';

declare module 'jspdf' {
  interface jsPDF {
    autoTable: (options: any) => jsPDF;
  }
}

export default function StudentsClass() {
  const [classes, setClasses] = useState<any[]>([]);
  const [sections, setSections] = useState<any[]>([]);
  const [selectedClass, setSelectedClass] = useState<number | null>(null);
  const [selectedSection, setSelectedSection] = useState<number | null>(null);
  const [students, setStudents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth.value);

  const getCookie = (name: string) => {
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let cookie of cookieArray) {
      cookie = cookie.trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length);
      }
    }
    return '';
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = getCookie('token');
        if (!token) {
          dispatch(setAuth(false));
          return;
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await axios.get('/users/user');
        dispatch(setAuth(true));
      } catch (e) {
        dispatch(setAuth(false));
      }
    };
    fetchUserData();
  }, [dispatch]);

  useEffect(() => {
    const fetchClasses = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/Branches/classes/');
        setClasses(response.data);
      } catch (error) {
        console.error('Error fetching classes:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchClasses();
  }, []);

  useEffect(() => {
    const fetchSectionsByClass = async () => {
      if (selectedClass) {
        try {
          setLoading(true);
          const response = await axios.get(
            `/Branches/sections/?class_id=${selectedClass}`
          );
          setSections(response.data);
        } catch (error) {
          console.error('Error fetching sections:', error);
        } finally {
          setLoading(false);
        }
      } else {
        setSections([]);
      }
    };
    fetchSectionsByClass();
  }, [selectedClass]);

  // Fetch Students Function


  useEffect(() => {
    const fetchStudents = async () => {
      if (!selectedClass) return;

      setLoading(true);
      try {
        let fetchUrl = `/Branches/students/?class_id=${selectedClass}`;
        if (selectedSection) {
          fetchUrl += `&section_id=${selectedSection}`;
        }

        const response = await axios.get(fetchUrl);
        setStudents(response.data.results || response.data || []);

      } catch (error) {
        console.error('Error fetching students:', error);
        setStudents([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedClass) {
      fetchStudents();
    }
  }, [selectedClass, selectedSection]);

  const filteredStudents = students.filter(student =>
    student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    student.guardian_number.includes(searchTerm)
  );

  const handleClassChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const classId = Number(e.target.value);
    setSelectedClass(classId);
    setSelectedSection(null);
  };

  const handleSectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const sectionId = Number(e.target.value);
    setSelectedSection(sectionId);
  };

  const generatePDF = () => {
    const doc = new jsPDF();
    doc.text('Warbixinta Ardayda', 14, 16);
    doc.autoTable({
      head: [['Magaca', 'Lambarka Masuulka', 'Cinwaanka', 'Degmada', 'Taariikhda Diiwaangelinta']],
      body: filteredStudents.map((student) => [
        student.name,
        student.guardian_number,
        student.address,
        student.district,
        student.date_reg,
      ]),
      startY: 20,
    });
    doc.save('students_report.pdf');
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredStudents.map((student) => ({
        Magaca: student.name,
        'Lambarka Masuulka': student.guardian_number,
        Cinwaanka: student.address,
        'Degmada': student.district,
        'Taariikhda Diiwaangelinta': student.date_reg,
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Ardayda');
    XLSX.writeFile(workbook, 'students_report.xlsx');
  };

  const printReport = () => {
    window.print();
  };

  return (
    <div className="dashboard-content">
      {auth ? (
        <>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
            <div>
              <h2 className="fw-bold text-dark mb-1">
                <FaUserGraduate className="me-2 text-primary" />
                Maamulka Fasalka
              </h2>
              <p className="text-muted mb-0">Kala saar oo maamul ardayda fasal iyo qeyb ahaan.</p>
            </div>
            {/* Action buttons could go here */}
          </div>

          <div className="card-modern p-4 mb-4">
            <div className="d-flex align-items-center mb-4">
              <div className="bg-primary bg-opacity-10 p-2 rounded-circle me-3">
                <i className="fas fa-filter text-primary"></i>
              </div>
              <h5 className="fw-bold text-dark mb-0">Kala Saar Ardayda</h5>
            </div>
            <div className="row g-3">
              <div className="col-md-5">
                <label htmlFor="classSelect" className="form-label fw-medium text-secondary small">
                  Dooro Fasalka
                </label>
                <select
                  id="classSelect"
                  onChange={handleClassChange}
                  value={selectedClass || ''}
                  className="form-select bg-light border-0"
                  disabled={loading}
                >
                  <option value="">Dooro fasal...</option>
                  {classes.map((cls) => (
                    <option key={cls.id} value={cls.id}>
                      {cls.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-5">
                <label htmlFor="sectionSelect" className="form-label fw-medium text-secondary small">
                  Dooro Qeybta
                </label>
                <select
                  id="sectionSelect"
                  onChange={handleSectionChange}
                  value={selectedSection || ''}
                  className="form-select bg-light border-0"
                  disabled={!selectedClass || loading}
                >
                  <option value="">Dooro qeyb...</option>
                  {sections.map((section) => (
                    <option key={section.id} value={section.id}>
                      {section.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <button
                  className="btn btn-outline-secondary w-100"
                  onClick={() => {
                    setSelectedClass(null);
                    setSelectedSection(null);
                  }}
                  disabled={!selectedClass && !selectedSection}
                >
                  Dib u Deji
                </button>
              </div>
            </div>
          </div>

          {(selectedClass || selectedSection) && (
            <div className="card-modern">
              <div className="card-body p-4">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 border-bottom pb-4">
                  <div className="d-flex align-items-center mb-3 mb-md-0">
                    <div className="bg-success bg-opacity-10 p-2 rounded-circle me-3">
                      <i className="fas fa-list text-success"></i>
                    </div>
                    <div>
                      <h5 className="fw-bold text-dark mb-0">Liiska Ardayda</h5>
                      <p className="text-muted small mb-0">{filteredStudents.length} arday ayaa la helay</p>
                    </div>
                  </div>

                  <div className="d-flex flex-column flex-md-row gap-3 w-100 w-md-auto">
                    <div className="input-group shadow-sm rounded-pill overflow-hidden bg-light border" style={{ minWidth: '220px' }}>
                      <span className="input-group-text bg-transparent border-0 ps-3">
                        <FaSearch className="text-muted" size={14} />
                      </span>
                      <input
                        type="text"
                        className="form-control border-0 bg-transparent shadow-none"
                        placeholder="Raadi ardayda..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        style={{ fontSize: '0.9rem' }}
                      />
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        className="btn btn-outline-danger rounded-pill d-flex align-items-center px-3"
                        onClick={generatePDF}
                        title="U Dhoofin PDF"
                      >
                        <FaFilePdf className="me-2" size={14} /> PDF
                      </button>
                      <button
                        className="btn btn-outline-success rounded-pill d-flex align-items-center px-3"
                        onClick={exportToExcel}
                        title="U Dhoofin Excel"
                      >
                        <FaFileExcel className="me-2" size={14} /> Excel
                      </button>
                      <button
                        className="btn btn-outline-secondary rounded-pill d-flex align-items-center px-3"
                        onClick={printReport}
                      >
                        <FaPrint className="me-1" size={12} /> Daabac
                      </button>
                    </div>
                  </div>
                </div>

                {loading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                      <span className="visually-hidden">Soo kabanaya...</span>
                    </div>
                  </div>
                ) : filteredStudents.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0">
                      <thead className="bg-light text-secondary">
                        <tr style={{ fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                          <th className="py-3 ps-4 border-0">Magaca</th>
                          <th className="py-3 border-0">Masuulka</th>
                          <th className="py-3 border-0">Cinwaanka</th>
                          <th className="py-3 border-0">Degmada</th>
                          <th className="py-3 border-0">Taariikhda</th>
                          <th className="py-3 pe-4 text-end border-0">Falalka</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredStudents.map((student) => (
                          <tr key={student.id} style={{ transition: 'background-color 0.2s' }}>
                            <td className="ps-4 py-3">
                              <div className="d-flex align-items-center">
                                <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '36px', height: '36px' }}>
                                  <FaUserGraduate size={14} />
                                </div>
                                <div>
                                  <div className="fw-bold text-dark">{student.name}</div>
                                  <small className="text-muted">Aqoonsi: {student.admission_number || 'N/A'}</small>
                                </div>
                              </div>
                            </td>
                            <td className="py-3">
                              <div className="d-flex flex-column small">
                                <span className="fw-medium text-dark">{student.nameOf_parent || '-'}</span>
                                <a href={`tel:${student.guardian_number}`} className="text-decoration-none text-muted">
                                  {student.guardian_number}
                                </a>
                              </div>
                            </td>
                            <td className="py-3 small text-muted" style={{ maxWidth: '150px' }}>{student.address || '-'}</td>
                            <td className="py-3">
                              <span className="badge bg-info bg-opacity-10 text-info px-2 py-1 rounded-pill fw-normal">
                                {student.district || 'N/A'}
                              </span>
                            </td>
                            <td className="py-3 small text-muted">{student.date_reg}</td>
                            <td className="py-3 pe-4 text-end">
                              <Link
                                to={`/student-details/${student.id}`}
                                className="btn btn-sm btn-outline-primary rounded-pill d-inline-flex align-items-center px-3"
                              >
                                <FaEye className="me-2" size={12} /> Arag Profile-ka
                              </Link>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="text-center py-4">
                    <div className="mb-2">
                      <FaUserGraduate size={32} className="text-muted" />
                    </div>
                    <h6 className="text-muted">Arday lalama helin</h6>
                    {searchTerm && (
                      <button
                        className="btn btn-link text-primary btn-sm"
                        onClick={() => setSearchTerm('')}
                      >
                        Tirtir raadinta
                      </button>
                    )}
                  </div>
                )}

              </div>
            </div>
          )}
        </>
      ) : (
        <div className="alert alert-danger text-center mt-5 py-3">
          <h6 className="mb-1">Ma aadan xaqiijin</h6>
          <p className="small mb-0">Fadlan gasho si aad u hesho boggan</p>
        </div>
      )}
    </div>
  );
}